import React from "react";
import { Helmet } from "react-helmet-async";
import { formatPageTitle } from "constants/site.constants";

type DocumentTitleProps = {
  title?: string;
};

/**
 * Sets document <title> for the current route. Child Helmet instances may override.
 */
export default function DocumentTitle({ title }: DocumentTitleProps) {
  return (
    <Helmet>
      <title>{formatPageTitle(title)}</title>
    </Helmet>
  );
}
